// Dashboard Moderation translations (pt-BR), loaded into dashboard.moderation by ./pt-BR.js
module.exports = {
  label: "Moderação",
  health: require('./moderation/pt-BR.health.js'),
};
